import { ParticipantRoutes } from "./participant";
import { AssessmentRoutes } from "./initialAssessments";
import { OnboardingRoutes } from "./onboarding/routes";

export const AppRoutes = () => (
  <>
    <ParticipantRoutes />
    <AssessmentRoutes />
    <OnboardingRoutes />
  </>
);
